import { Preferences } from "@capacitor/preferences";
import { Capacitor } from "@capacitor/core";
export async function getDeviceId() {
    const isNative = Capacitor.isNativePlatform();
    const key = "app_installation_device_id";
    if (!isNative) {
        const saved = localStorage.getItem(key);
        if (saved) return saved;
        const newId = crypto.randomUUID();
        localStorage.setItem(key, newId);
        return newId;
    }
    const { value } = await Preferences.get({ key });
    if (value) return value;
    const newId = crypto.randomUUID();
    await Preferences.set({ key, value: newId });
    return newId;
}
